
// import { combineReducers } from 'redux';
import {
  QUOTATIONS_PAGINATOR_SET_CONFIGURATION_EMITTED_QUOTATIONS,

  QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_REQUEST,
  QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_SUCCESS,
  QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_ERROR,
} from 'Redux/types/tableQuotationsTypes';
import paginate from 'Redux/reducers/paginationReducer';


const quotationsEmitted = paginate({
  setPaginationConfigType: QUOTATIONS_PAGINATOR_SET_CONFIGURATION_EMITTED_QUOTATIONS,
  types: [
    QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_REQUEST,
    QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_SUCCESS,
    QUOTATIONS_PAGINATOR_GET_EMITTED_QUOTATIONS_ERROR,
  ],
});

export default quotationsEmitted;
